import {
  updateNotaryJobs,
  addJobToQueue,
  removeJobFromQueue,
  addAcceptedQueueJob,
  removeAcceptedQueueJob,
  addRealTimeRequest,
  setExpiredExpeditedRequests,
} from "../notaryActions";

import { updateNotaryUser } from "../notaryActions";
import { handleSessionExpiredLogout } from "../sessionsActions";

export const notarySessionOnMessage =
  (receivedData) => async (dispatch, getState) => {
    switch (receivedData.event) {
      case "logout":
        dispatch(handleSessionExpiredLogout());
        break;
      case "notary_user_update":
        dispatch(updateNotaryUser(receivedData.data));
        break;
      case "update_notary_jobs":
        dispatch(updateNotaryJobs(receivedData.data));
        break;
      case "broadcast_queue_job":
        dispatch(addJobToQueue(receivedData.data));
        break;
      case "broadcast_remove_queue_job":
        dispatch(removeJobFromQueue(receivedData.data));
        break;
      case "update_accepted_job_list":
        dispatch(addAcceptedQueueJob(receivedData.data));
        break;
      case "remove_accepted_job_list":
        dispatch(removeAcceptedQueueJob(receivedData.data));
        break;
      case "new_ron_request":
        dispatch(addRealTimeRequest(receivedData.data));
        break;
      case "dismiss_ron_request":
        // Remove dismissed request from Redux state
        dispatch({
          type: "DISMISS_RON_REQUEST",
          payload: receivedData.data.request_id,
        });
        break;
      case "remove_real_time_request":
        // Remove accepted request from Redux state (when another notary accepts)
        dispatch({
          type: "DISMISS_RON_REQUEST",
          payload: receivedData.data.request_id,
        });
        break;
      case "expired_expedited_requests_updated":
        const currentNotaryAdminId =
          getState()?.notarySession?.user?.notary_admin_id || "permitRockstar";
        const payloadNotaryAdminId =
          receivedData?.data?.notary_admin_id || "permitRockstar";

        // Safety check: never mix pools on the client.
        if (currentNotaryAdminId !== payloadNotaryAdminId) {
          break;
        }

        dispatch(
          setExpiredExpeditedRequests(
            receivedData?.data?.expired_expedited_requests || [],
          ),
        );
        break;
      case "instant_ron_processing":
        // Store websocket message for AcceptInstant component
        dispatch({ type: "STORE_WEBSOCKET_MESSAGE", payload: receivedData });
        break;
      case "instant_ron_accepted":
        // Store websocket message for AcceptInstant component
        dispatch({ type: "STORE_WEBSOCKET_MESSAGE", payload: receivedData });
        break;
      default:
        return;
    }
  };
